var map = {
	"./screen1.png": 1742,
	"./screen2.png": 1743,
	"./screen3.png": 1744,
	"./screen4.png": 1745,
	"./screen5.png": 1746,
	"./screen6.png": 1747,
	"./screen7.png": 1748
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1741;